module.exports = __webpack_public_path__ + "static/img/liandong2.ca5b78a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/white/liandong2.png
// module id = crlw
// module chunks = 24